import React from 'react'
import { Pane, Text } from 'evergreen-ui'
import { useStatusContent } from '../../../config/roundContent'

const StatusRegister_11 = ({ DataRegister }) => {
  const row = DataRegister?.[0] || {}
  const { statusContent } = useStatusContent(row.ROB_ID, "11")
  const title = statusContent.titleText || 'ไม่ผ่านการคัดเลือก'
  const body = statusContent.bodyText || ''

  return (
    <>
      <Pane
        color="#ffffff"
        backgroundColor="red"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontWeight={700}
        marginBottom={8}
        display="flex" alignItems="center" justifyContent="center"
      >
        <Text color="#ffffff" height="100%" paddingY={4} paddingX={5} fontSize={16}>
          {title}{" "}
          {row.QUOTA_NAME +
            " " +
            row.Major1_faculty_name +
            " หลักสูตร " +
            row.Major1_LEVEL_OPEN_NAME +
            " " +
            row.Major1_MAJOR_ID +
            " : " +
            row.Major1_MAJOR_NAME}
        </Text>
      </Pane>

      {body ? (
        <Pane
          color="#000000"
          backgroundColor="#686868"
          height="100%"
          paddingY={4}
          paddingX={5}
          fontSize={16}
          fontWeight={700}
          marginBottom={8}
          display="flex" alignItems="center" justifyContent="center"
        >
          <Text color="#ffffff" fontWeight={700}>
            {body}
          </Text>
        </Pane>
      ) : null}
    </>
  )
}

export default StatusRegister_11
